/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Inbound_DeliveryInputs */

const en_field_inbound_delivery = /** @type {(inputs: Field_Inbound_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbound delivery`)
};

/**
* | output |
* | --- |
* | "Inbound delivery" |
*
* @param {Field_Inbound_DeliveryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_inbound_delivery = /** @type {((inputs?: Field_Inbound_DeliveryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Inbound_DeliveryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_inbound_delivery(inputs)
});